import React from 'react';
import PropTypes from 'prop-types';

import { getColorHex, getSwatchImage } from '../../Utils/SwatchUtils';

import { StyledLi, StyledColorLabel, StyledSizeLabel, StyledSizeLabelMessage, StyledHiddenInput } from './VisualizerFilterListItemStyles';

var VisualizerFilterListItem = function VisualizerFilterListItem(props) {
  var handleChange = function handleChange(filter) {
    if (props.selectedFilter === filter) {
      props.handleSelectedFilterChange('');
    } else {
      props.handleSelectedFilterChange(filter);
    }
  };

  return props.filterType === 'COLOR' ? React.createElement(
    StyledLi,
    null,
    React.createElement(
      StyledColorLabel,
      {
        hexValue: getColorHex(props.filter.toLowerCase()),
        selected: props.filter === props.selectedFilter
      },
      React.createElement(StyledHiddenInput, {
        type: 'checkbox',
        onChange: function onChange() {
          return handleChange(props.filter);
        },
        checked: props.filter === props.selectedFilter,
        'aria-label': 'Toggle ' + props.filter + ' filter'
      }),
      getColorHex(props.filter.toLowerCase()) === undefined && React.createElement('img', { src: getSwatchImage(props.filter), alt: props.filter })
    )
  ) : React.createElement(
    StyledLi,
    null,
    React.createElement(
      StyledSizeLabel,
      { selected: props.filter === props.selectedFilter },
      React.createElement(StyledHiddenInput, {
        type: 'radio',
        onChange: function onChange() {
          return handleChange(props.filter);
        },
        checked: props.filter === props.selectedFilter,
        'aria-label': 'Toggle ' + props.filter + ' filter',
        name: props.categoryTitle
      }),
      props.filter.replace('-', ' ')
    ),
    React.createElement(
      StyledSizeLabelMessage,
      null,
      props.filter.includes('Twin') ? '(incl. 1 sham)' : '(incl. 2 shams)'
    )
  );
};

VisualizerFilterListItem.propTypes = {
  filter: PropTypes.string,
  selectedFilter: PropTypes.string,
  handleSelectedFilterChange: PropTypes.func,
  filterType: PropTypes.oneOf(['SIZE', 'COLOR']),
  categoryTitle: PropTypes.string.isRequired
};

export default VisualizerFilterListItem;